import { jsxs, jsx } from "react/jsx-runtime";
import { sectionFadeInStyle } from "./utils.js";
import { SurveyCarousel } from "../SurveyCarousel.js";
function DataSurveySectionPart({ part }) {
  var _a;
  const section = part.data;
  if (!((_a = section == null ? void 0 : section.surveys) == null ? void 0 : _a.length)) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "concierge-survey-section",
      style: { animation: "concierge-fade-in 0.35s ease-out both" },
      children: [
        /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
        section.title && /* @__PURE__ */ jsx("h3", { className: "concierge-section-title", children: section.title }),
        /* @__PURE__ */ jsx(SurveyCarousel, { surveys: section.surveys })
      ]
    }
  );
}
export {
  DataSurveySectionPart
};
//# sourceMappingURL=DataSurveySectionPart.js.map
